export default {
  app: {
    title: '栖云数坊',
    subtitle: '基于贝壳网的租房数据爬取和分析平台',
    footer: '© {year} 栖云数坊 · 基于Vue.js和FastAPI开发 · 版权所有'
  },
  menu: {
    home: '首页',
    tasks: '爬虫任务',
    ipManagement: 'IP管理',
    scheduledTasks: '定时任务',
    houses: '房源数据',
    analysis: '数据分析',
    settings: '系统设置'
  },
  home: {
    systemIntro: '系统功能介绍',
    introText: '本系统是一个基于Python技术栈开发的租房数据分析平台，通过爬取贝壳网的租房信息，并使用PySpark进行数据处理和分析，最终以可视化图表的形式展示市场洞察。',
    mainFeatures: '主要功能:',
    dataCollection: '数据采集',
    dataCollectionDesc: '支持多城市租房数据爬取，自动解析房源价格、面积、位置等关键信息',
    dataAnalysis: '数据分析',
    dataAnalysisDesc: '使用PySpark对租房数据进行多维度分析，包括区域分析、户型分析、价格分布等',
    visualization: '可视化展示',
    visualizationDesc: '通过ECharts图表直观展示分析结果，帮助用户快速了解租房市场情况',
    quickStart: '快速开始:',
    step1: '在右侧创建新的爬虫任务，选择城市和爬取页数',
    step2: '等待爬虫任务完成后，在任务列表中查看详情',
    step3: '点击"查看数据"浏览爬取的房源信息，或点击"分析数据"进行数据分析',
    step4: '在数据分析页面查看生成的可视化图表',
    createTask: '创建新爬虫任务',
    viewAnalysis: '查看分析',
    step1Title: '创建任务',
    step2Title: '查看结果',
    step3Title: '分析数据',
    city: '城市',
    selectCity: '请选择城市',
    crawlPages: '爬取页数',
    startCrawling: '开始爬取',
    reset: '重置',
    recentTasks: '最近爬虫任务',
    viewAll: '查看全部',
    noTasks: '暂无爬虫任务',
    status: '状态:',
    startTime: '开始时间:',
    houseCount: '房源数:',
    view: '查看',
    taskStatus: {
      inProgress: '进行中',
      completed: '完成',
      failed: '失败'
    },
    fetchTasksFailed: '获取最近任务失败',
    taskCreatedSuccess: '成功创建爬虫任务',
    请设置爬取页数: '请设置爬取页数',
    爬虫任务创建成功: '爬虫任务创建成功'
  },
  notFound: '页面未找到',
  nav: {
    home: '首页',
    taskList: '任务列表',
    scheduledTasks: '定时任务',
    scheduledtasks: '定时任务',
    ipManagement: 'IP管理',
    houseList: '房源列表',
    analysis: '数据分析',
    UserProfile: '个人资料',
    UserSettings: '账户设置',
    SystemSettings: '系统设置'
  },
  auth: {
    login: '登录',
    register: '注册',
    forgotPassword: '忘记密码',
    forgotPasswordTitle: '找回密码',
    forgotPasswordSubtitle: '输入您的邮箱地址，我们将发送验证码',
    sendResetLink: '发送重置链接',
    sendVerificationCode: '发送验证码',
    resetPasswordTitle: '重置密码',
    resetPasswordSubtitle: '请输入验证码和新密码',
    verificationCode: '验证码',
    newPassword: '新密码',
    confirmNewPassword: '确认新密码',
    resendCode: '重新发送验证码',
    rememberedPassword: '想起密码了?',
    registerTitle: '创建新账户',
    registerSubtitle: '填写以下信息完成注册',
    loginTitle: '欢迎回来',
    loginSubtitle: '请登录您的账户',
    username: '用户名',
    email: '邮箱',
    password: '密码',
    confirmPassword: '确认密码',
    rememberMe: '记住我',
    forgotYourPassword: '忘记密码?',
    noAccount: '还没有账户?',
    alreadyHaveAccount: '已有账户?',
    agreeTerms: '我同意服务条款和隐私政策',
    termsLink: '服务条款',
    haveAccount: '已有账户?',
    createAccount: '创建账户',
    resetPassword: '重置密码'
  },
  user: {
    profile: '个人资料',
    profileDesc: '查看和编辑您的个人信息',
    settings: '账户设置',
    settingsDesc: '管理您的账户设置和偏好',
    logout: '退出登录',
    username: '用户名',
    email: '邮箱',
    changePassword: '修改密码',
    currentPassword: '当前密码',
    currentPasswordPlaceholder: '请输入当前密码',
    newPassword: '新密码',
    newPasswordPlaceholder: '请输入新密码',
    confirmNewPassword: '确认新密码',
    confirmPasswordPlaceholder: '请再次输入新密码',
    saveChanges: '保存更改',
    changeAvatar: '更换头像',
    deleteAccount: '删除账户',
    deleteAccountConfirmation: '确认删除账户',
    deleteAccountWarning: '警告：此操作将永久删除您的账户和所有相关数据，且无法恢复。',
    deleteConfirmation: '确认',
    deleteConfirmationPlaceholder: '请输入DELETE确认删除',
    passwordRequired: '请输入密码',
    confirmationRequired: '请输入确认文本',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    notificationSettings: '通知设置',
    emailNotifications: '邮件通知',
    emailNotificationsDesc: '接收系统相关更新和重要通知的邮件',
    taskCompletionNotifications: '任务完成通知',
    taskCompletionNotificationsDesc: '当爬虫任务完成时接收通知',
    displaySettings: '显示设置',
    language: '语言',
    theme: '主题',
    themeLight: '浅色',
    themeDark: '深色',
    themeSystem: '跟随系统',
    themeDesc: '选择应用的显示主题',
    accountSettings: '账户设置',
    dataSharing: '数据共享',
    dataSharingDesc: '允许系统收集匿名使用数据以改进服务',
    dangerZone: '危险区域',
    dangerZoneDesc: '以下操作可能会导致不可逆的数据丢失'
  },
  settings: {
    systemSettings: '系统设置',
    systemSettingsDesc: '管理系统整体设置和配置',
    databaseSettings: '数据库设置',
    databaseConfig: '数据库配置',
    dataManagement: '数据管理',
    systemInfo: '系统信息',
    systemStatus: '系统状态',
    about: '关于',
    
    dbHost: '主机地址',
    dbPort: '端口',
    dbName: '数据库名',
    dbUser: '用户名',
    dbPassword: '密码',
    
    purgeData: '清除数据',
    purgeDataDesc: '删除所有爬取的房源数据和任务记录',
    purgeDataConfirmation: '确认清除数据',
    purgeDataWarning: '此操作将永久删除所有房源数据和任务记录，且无法恢复。',
    purgeConfirmation: '我已了解风险，确认清除所有数据',
    
    exportData: '导出数据',
    exportDataDesc: '导出所有系统设置和配置数据',
    
    version: '版本',
    lastUpdate: '最后更新',
    apiStatus: 'API状态',
    dbStatus: '数据库状态',
    userCount: '用户数',
    houseCount: '房源数',
    taskCount: '任务数',
    startupTime: '启动时间',
    uptime: '运行时间',
    diskUsage: '磁盘使用',
    
    adminOnlyNotice: '只有管理员可以修改数据库设置',
    resetToDefault: '重置为默认',
    saveChanges: '保存更改',
    
    aboutText: '这是一个基于Vue.js和FastAPI开发的租房数据分析系统，能够爬取、存储和分析租房数据。',
    sourceCode: '源代码',
    documentation: '文档',
    reportBug: '报告问题'
  },
  scheduledTasks: {
    title: '定时任务',
    createTask: '创建任务',
    editTask: '编辑任务',
    taskName: '任务名称',
    city: '城市',
    selectCity: '请选择城市',
    pagesToCrawl: '爬取页数',
    schedule: '执行计划',
    nextRun: '下次执行时间',
    status: '状态',
    actions: '操作',
    runTime: '执行时间',
    weekday: '星期',
    monthDay: '日期',
    daily: '每天',
    weekly: '每周',
    monthly: '每月',
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六',
    sunday: '星期日',
    nameRequired: '请输入任务名称',
    nameLength: '长度在2到100个字符',
    cityRequired: '请选择城市',
    pagesRequired: '请输入爬取页数',
    pagesRange: '页数必须在1到100之间',
    timeRequired: '请选择执行时间',
    warning: '警告',
    confirm: '确认',
    cancel: '取消',
    confirmDeleteTask: '确定要删除定时任务 {name} 吗？',
    deleteSuccess: '删除成功',
    deleteError: '删除失败',
    createSuccess: '创建成功',
    updateSuccess: '更新成功',
    saveError: '保存失败',
    fetchTasksError: '获取任务列表失败',
    fetchCitiesError: '获取城市列表失败',
    everyDayAt: '每天 {time}',
    everyWeekAt: '每周{day} {time}',
    everyMonthAt: '每月{day}日 {time}'
  },
  cancel: '取消',
  ipManagement: {
    currentIp: '当前IP地址',
    refreshIp: '刷新IP',
    proxyPool: '代理IP池',
    ipSettings: 'IP设置',
    addProxy: '添加代理',
    ipAddress: 'IP地址',
    port: '端口',
    location: '位置',
    status: '状态',
    latency: '延迟',
    lastUsed: '最后使用时间',
    actions: '操作',
    test: '测试',
    delete: '删除',
    rotationStrategy: 'IP轮换策略',
    rotationInterval: '轮换间隔',
    maxFailures: '最大失败次数',
    autoAddProxies: '自动添加代理',
    minutes: '分钟',
    failures: '次',
    saveSettings: '保存设置',
    resetSettings: '重置设置',
    username: '用户名',
    password: '密码',
    strategies: {
      manual: '手动切换',
      time: '定时轮换',
      failure: '失败后轮换',
      request: '请求数达到后轮换'
    },
    statusTypes: {
      active: '可用',
      inactive: '不可用',
      error: '错误'
    }
  },
  common: {
    confirm: '确定',
    cancel: '取消',
    save: '保存',
    delete: '删除'
  },
  taskList: {
    title: '爬虫任务列表',
    refresh: '刷新',
    status: {
      inProgress: '进行中',
      completed: '完成',
      failed: '失败'
    },
    messages: {
      taskInProgress: '爬虫任务进行中，暂无法查看数据',
      cannotAnalyzeInProgress: '爬虫任务进行中，暂无法分析数据',
      noDataToAnalyze: '没有成功爬取的数据，无法进行分析',
      analysisStarted: '数据分析任务已启动',
      analysisStartFailed: '启动数据分析任务失败',
      cannotDeleteInProgress: '爬虫任务进行中，无法删除',
      confirmDelete: '确定要删除ID为{id}的{city}爬虫任务吗？此操作将删除任务及相关数据，且不可恢复。',
      deleteConfirmTitle: '删除确认',
      deleteSuccess: '任务删除成功',
      deleteFailed: '删除任务失败',
      fetchTasksFailed: '获取任务列表失败'
    },
    columns: {
      id: 'ID',
      city: '城市',
      status: '状态',
      startTime: '开始时间',
      endTime: '结束时间',
      totalItems: '总条目',
      successItems: '成功条目',
      progress: '进度',
      actions: '操作'
    },
    crawlerRunning: '爬虫任务正在初始化',
    waitForCrawler: '爬虫任务刚刚启动，数据库正在处理中，请稍后再查看任务列表',
    remainingTime: '预计剩余时间',
    viewAnyway: '仍然查看'
  }
}; 